import React from "react";
import FormSwitch from 'jd-library/FormSwitch';
import styles from './switch.scss';

export default (props) => {
	return (
		<FormSwitch 
			{...props}
			className={`${styles['b2b-switch']} ${props.className || ''}`}
			labelClass={`${styles['b2b-label']} ${props.labelClass || ''}`}
		/>
	)
}